import _isNumber from 'lodash.isnumber';

export function isNumber(value: any) {
  return _isNumber(value);
}
